import vuetify from '@/plugins/vuetify'
import { groupBy, round, sumBy } from 'lodash'

const bpt = vuetify.framework.breakpoint

export const getNumEmptySlots = (numCards) => {
  const cardsPerRow = bpt.smAndDown ? 1
    : bpt.lgAndDown ? 2
      : 3
  return (cardsPerRow - (numCards % cardsPerRow)) % cardsPerRow
}

export const withLoadsByProduct = (destinations) => destinations.map(destination => ({
  ...destination,
  loadsByProduct: Object.values(groupBy(destination.loadsByFromAccountAndProduct, lbfp => lbfp.product ?? lbfp.productName))
    .map(productGroup => ({
      product: productGroup[0].product ?? productGroup[0].productName,
      loadCount: sumBy(productGroup, 'loadCount'),
      tons: round(sumBy(productGroup, 'tons') ?? 0, 3),
      ticketIds: productGroup.flatMap(lbfp => lbfp.ticketIds ?? [])
    }))
}))
